import { Star } from "lucide-react";

const LABELS = { service: "Servizio", punctuality: "Puntualità", quality: "Qualità" };

export default function RatingDetails({ details, size = "w-3 h-3" }) {
  if (!details) return null;
  return (
    <div className="mt-1.5 flex flex-wrap gap-x-4 gap-y-1" data-testid="rating-details">
      {Object.entries(LABELS).map(([k, label]) => details[k] ? (
        <div key={k} className="flex items-center gap-1 text-[11px] text-slate-600">
          <span className="font-mono uppercase tracking-widest">{label}</span>
          <span className="flex">{[1,2,3,4,5].map(n => <Star key={n} className={`${size} ${n <= details[k] ? "fill-amber-500 text-amber-500" : "text-slate-300"}`} />)}</span>
        </div>
      ) : null)}
    </div>
  );
}
